module.exports = __webpack_public_path__ + "static/media/cusano.4cfdb9b5.png";